<template>
  <div class="scroll-page" ref="scrollwrapper">
    <AppHeader @refreshPage="init" />
    <div
      class="container"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10">
      <div class="top-box" v-if="this.$store.state.token">
        <div class="control-bar">
          <div class="logout" @click="handleLogout">{{ $t('logout') }}</div>
          <div class="address" @click="handleRoute('/user/address')">
            {{ $t('new.text34') }}
          </div>
        </div>
        <div class="welcome">
          {{ $t('hi') }},
          {{
            $store.state.user_info && $store.state.user_info.email.split('@')[0]
          }}
        </div>
      </div>
      <div class="list1" v-if="$store.state.user_info">
        <div class="item">
          <div class="flexable">
            <div class="text" :class="'text0'">
              <div class="label" @click="handleQa('1')">
                {{ $t('web5token') }}
              </div>
              <div class="value">
                {{ $handleNum($store.state.user_info.web5_score) }}
              </div>
            </div>
            <div class="btns">
              <el-button
                type="primary"
                size="sm"
                @click="handleDeposit('web5')"
                >{{ $t('deposit') }}</el-button
              >
              <el-button
                type="default"
                size="sm"
                @click="handleWithdraw('web5')"
                >{{ $t('withdraw') }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="item">
          <div class="flexable">
            <div class="text text1">
              <div class="label" @click="handleQa('2')">
                {{ $t('krazetoken') }}
              </div>
              <div class="value">
                {{ $handleNum($store.state.user_info.kraze_token) }}
              </div>
              <!-- <div class="des" v-if="$store.state.user_info.usd">
                ≈ {{ $handleNum($store.state.user_info.usd) }} USD
              </div> -->
            </div>
            <div class="btns">
              <el-button
                type="primary"
                size="sm"
                @click="handleDeposit('swap')"
                >{{ $t('swap') }}</el-button
              >
              <el-button
                type="default"
                size="sm"
                @click="handleWithdraw('kraze')"
                >{{ $t('withdraw') }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="item ac">
          <span class="arrow-right" @click="handleTransfer">{{
            $t('add.text87')
          }}</span>
        </div>
        <div class="item ac">
          <span class="arrow-share" @click="handleShare">{{
            $t('new.text73')
          }}</span>
        </div>
      </div>
      <div ref="fixwrapper" :class="fixwrapper ? 'fixwrapper' : ''">
        <div class="navbar-area"></div>
        <mt-navbar v-model="selected">
          <mt-tab-item id="1" clss="up">{{ $t('nfts') }}</mt-tab-item>
          <mt-tab-item id="2" clss="up">{{ $t('activities') }}</mt-tab-item>
          <mt-tab-item id="3" clss="up">{{ $t('referral') }}</mt-tab-item>
          <mt-tab-item id="4" clss="up">{{ $t('income') }}</mt-tab-item>
        </mt-navbar>
        <!-- tab-container -->
        <mt-tab-container v-model="selected">
          <mt-tab-container-item id="1">
            <div class="switch-btns">
              <div
                class="item"
                v-for="(item, index) in nftCategories"
                :key="index"
                :class="index === currentNft ? 'active' : ''"
                @click="handleSwitdh(index)">
                {{ item.label }}
              </div>
            </div>
            <div
              v-for="(item3, index3) in nftCategories"
              :key="index3"
              v-show="index3 === currentNft">
              <div class="list2" v-if="item3.data.length > 0">
                <div
                  class="item"
                  @click="handleRoute('/user/mint')"
                  v-if="
                    $store.state.user_info &&
                    !$store.state.user_info.own_nft &&
                    index3 === 0
                  ">
                  <div class="img-box empty"></div>
                  <div class="price up">
                    <span class="special">{{ $t('accountpage.text1') }}</span>
                  </div>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in item3.data"
                  :class="index3 === 1 ? 'type2' : index3 === 2 ? 'type3' : ''"
                  :key="index"
                  @click="handleRoute('/user/nftdetail', item)">
                  <div
                    class="img-box"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + item.image + ')'
                    }">
                    <div class="my-tip" v-if="item.from === 2">
                      <span>{{ $t('accountpage.text2') }}</span>
                    </div>
                    <div
                      class="win-box"
                      v-if="index3 === 2 && item.my_reward_score !== 0">
                      <span
                        >{{ $handleNum(item.my_reward_score) }}
                        {{ $t('web5token') }} !</span
                      >
                    </div>
                  </div>
                  <div class="price up" v-if="index3 === 0">
                    <span class="special">{{ item.nft_name }}</span>
                  </div>
                  <div class="av type2" v-if="index3 === 1">
                    {{ item.event_title }}
                  </div>
                </div>
                <EmptyBox
                  :text="$t('nonft')"
                  type="nft"
                  v-if="nftList && nftList.length === 0" />
                <el-button
                  v-if="nftList && nftList.length === 0"
                  class="el-button--special2 block"
                  @click="handleRoute('/user/howtoplay')"
                  style="margin: 0.5rem 15% !important; width: 70%"
                  >{{ $t('add.text77') }}</el-button
                >
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="2">
            <div class="list1" v-if="activities && activities.length > 0">
              <div
                class="item arrow"
                v-for="(item, index) in activities"
                :key="index"
                @click="handleActivity(item)">
                <div class="flexable top">
                  <div
                    class="img"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + item.image + ')'
                    }"></div>
                  <div class="activity-info">
                    <div class="name">{{ item.name }}</div>
                    <div class="date">
                      {{ item.started_at + ' - ' + item.opened_at }}
                    </div>
                    <div
                      class="status-component"
                      :class="'status' + item.status">
                      {{ item.statusName }}
                    </div>
                    <div class="btn" v-if="item.status === 3">
                      <span v-if="item.win_score > 0">
                        🎉 {{ $t('activitypage.text9') }}
                        <span class="price">{{ item.win_score }}</span></span
                      >
                      <span v-else-if="item.lose_token > 0"
                        >🎉 {{ $t('activitypage.text9') }}
                        <span class="price3">{{ item.lose_token }}</span></span
                      >
                      <span class="no" v-else>{{
                        $t('activitypage.text10')
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="no-more">- {{ $t('add.text73') }} -</div>
            </div>
            <EmptyBox
              v-if="activities && activities.length === 0"
              type="act"
              :text="$t('noactivity')" />
          </mt-tab-container-item>
          <mt-tab-container-item id="3">
            <div class="detail-box">
              <div class="refer-box">
                <div v-html="$t('add.text69')"></div>
              </div>
              <div class="jackpot type2">
                <div class="label">{{ $t('add.text70') }}</div>
                <div class="val">
                  {{
                    $store.state.user_info &&
                    $store.state.user_info.invite_reward
                  }}
                </div>
              </div>
              <div class="me-box">
                <div class="refer-tit">
                  <span>{{ $t('add.method') }} 1</span>
                  <span class="de">{{ $t('add.text71') }}</span>
                </div>
                <CopyBox :copyText="sharePath" />
                <div
                  class="refer-tit"
                  style="border-top: 1px solid #6a6a6a; padding-top: 0.2rem">
                  <span>{{ $t('add.method') }} 2</span>
                  <span class="de">{{ $t('add.text72') }}</span>
                  <div class="share" @click="handleShare">
                    <span>{{ $t('share') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-title5">{{ $t('accountpage.text7') }}</div>
            <div class="list4">
              <div
                class="flexable"
                v-for="(item, index) in referralList"
                :key="index">
                <div class="label">{{ item.email }}</div>
                <div class="date">{{ item.created_at }}</div>
              </div>
              <div class="no-more" v-if="!referralParams.more">
                - {{ $t('add.text73') }} -
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="4">
            <div class="list1" v-if="incomeList && incomeList.length > 0">
              <div v-for="(item, index) in incomeList" :key="index">
                <div class="item" v-if="item.category === 1">
                  <div class="flexable top" style="position: relative">
                    <div
                      class="img"
                      @click="handleRoute('/user/activity', item)"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item.image + ')'
                      }"></div>
                    <div class="activity-info">
                      <div
                        class="name"
                        @click="handleRoute('/user/actdetail', item)">
                        {{ item.name }}
                      </div>
                      <div class="date">
                        {{ item.started_at }} - {{ item.locked_at }}
                      </div>
                      <div
                        class="status-component"
                        :class="'status' + item.status">
                        {{ item.statusName }}
                      </div>
                      <div class="share" @click="handleShare('act', item)">
                        <span> {{ $t('share') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="total-box flexable">
                    <div class="total">
                      <b>{{ item.payment }}</b
                      ><br />
                      {{ $t('payment') }}
                    </div>
                    <div class="total">
                      <b>{{ item.participants }}</b
                      ><br />
                      {{ $t('participants') }}
                    </div>
                    <div class="total">
                      <b>{{ item.income }}</b
                      ><br />
                      {{ $t('income') }}
                    </div>
                  </div>
                </div>
                <div v-else class="item">
                  <div class="flexable top" style="position: relative">
                    <div
                      class="img2"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item.image + ')'
                      }"
                      @click="handleRoute2('/user/nftdetail', item)"></div>
                    <div class="activity-info">
                      <div
                        class="name"
                        @click="handleRoute2('/user/nftdetail', item)">
                        {{ item.name }}
                      </div>
                      <div class="price2">{{ item.income }}</div>
                      <div class="share" @click="handleShare('nft', item)">
                        <span> {{ $t('share') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="total-box flexable">
                    <div class="total">
                      <b>{{ item.payment }}</b
                      ><br />
                      {{ $t('payment') }}
                    </div>
                    <div class="total">
                      <b>{{ item.participants }}</b
                      ><br />
                      {{ $t('participants') }}
                    </div>
                    <div class="total">
                      <b>{{ item.income }}</b
                      ><br />
                      {{ $t('income') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="no-more">- {{ $t('add.text73') }} -</div>
            </div>
            <EmptyBox
              v-if="incomeList && incomeList.length === 0"
              type="act"
              :text="$t('add.text78')" />
          </mt-tab-container-item>
        </mt-tab-container>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box" v-if="popType === 'type'">
        <div class="pop-title" style="margin-bottom: 0.37rem">
          {{ $t('accountpage.text8') }}
        </div>
        <div class="des al">{{ $t('add.text16') }}</div>
        <el-button
          class="el-button--special block"
          style="margin: 0.23rem 0 0.46rem 0"
          @click="handleYes"
          >{{ $t('add.text17') }}</el-button
        >
        <el-button
          class="el-button--special block"
          style="margin: 0.23rem 0"
          @click="handleNo"
          >{{ $t('add.text18') }}
        </el-button>
      </div>
      <div class="pop-box deposit" v-if="popType === 'withdrawWeb5'">
        <div class="pop-title" style="margin-bottom: 0.38rem">
          {{ $t('add.text46') }}
        </div>
        <el-form
          :model="modelForm"
          status-icon
          ref="modelForm"
          label-width="100px"
          label-position="top">
          <el-form-item
            prop="token"
            :label="$t('add.text32')"
            :rules="[
              {
                required: true,
                message: $t('add.text54'),
                trigger: 'blur'
              }
            ]">
            <el-input
              v-model="modelForm.token"
              class="iconprice"
              oninput="value=value.replace(/[^\d]/g,'')"
              clearable
              @change="handleChange"></el-input>
            <div class="tipss" v-if="showTipss">
              {{ $t('add.text45', { price: 10000 }) }}
            </div>
          </el-form-item>
          <div class="about">= {{ usdtValue }} USDT</div>
          <el-form-item
            prop="wallet_address"
            :label="$t('add.text55')"
            :rules="[
              {
                required: true,
                message: $t('add.text53'),
                trigger: 'blur'
              }
            ]">
            <el-input v-model="modelForm.wallet_address"></el-input>
          </el-form-item>
          <el-button
            style="margin-top: 0.3rem"
            type="primary"
            @click="submitForm('modelForm')"
            class="block el-button--special"
            >{{ $t('withdraw') }}</el-button
          >
          <div class="tip-box" v-html="$t('add.text48')"></div>
        </el-form>
      </div>
      <div class="pop-box deposit" v-if="popType === 'withdrawKraze'">
        <div class="pop-title" style="margin-bottom: 0.38rem">
          {{ $t('add.text49') }}
        </div>
        <el-form
          :model="modelForm1"
          status-icon
          ref="modelForm1"
          label-width="100px"
          label-position="top">
          <el-form-item
            prop="token"
            :label="$t('add.text74')"
            :rules="[
              {
                required: true,
                message: $t('add.text52'),
                trigger: 'blur'
              }
            ]">
            <el-input
              v-model="modelForm1.token"
              class="iconprice type2"
              oninput="value=value.replace(/[^\d]/g,'')"
              clearable
              @change="handleChange1"></el-input>
            <div class="tipss" v-if="showTipss">
              {{ $t('add.text45', { price: 10000 }) }}
            </div>
          </el-form-item>
          <div class="about">= {{ usdtValue1 }} USDT</div>
          <el-form-item
            prop="wallet_address"
            :label="$t('add.text55')"
            :rules="[
              {
                required: true,
                message: $t('add.text53'),
                trigger: 'blur'
              }
            ]">
            <el-input v-model="modelForm1.wallet_address"></el-input>
          </el-form-item>
          <el-button
            style="margin-top: 0.3rem"
            type="primary"
            @click="submitForm('modelForm1')"
            class="block el-button--special"
            >{{ $t('withdraw') }}</el-button
          >
          <div class="tip-box" v-html="$t('add.text101')"></div>
        </el-form>
      </div>
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div class="pop-box buy" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('accountpage.text8') }}</div>
        <div class="result-box">
          <div class="h icons success2">{{ $t('accountpage.text9') }}</div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.init()
              this.popupVisible = false
            }
          "
          >{{ $t('completed') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'success2'">
        <div class="pop-title">{{ $t('add.text46') }}</div>
        <div class="result-box" style="margin-top: 0.5rem">
          <div
            class="h hh icons success"
            style="background-size: 0.66rem; padding-top: 0.86rem">
            {{ $t('add.text47') }}
          </div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.init()
              this.popupVisible = false
            }
          "
          >{{ $t('add.text50') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'success3'">
        <div class="pop-title">{{ $t('add.text49') }}</div>
        <div class="result-box" style="margin-top: 0.5rem">
          <div
            style="
              text-align: center;
              font-size: 0.44rem;
              margin-bottom: 0.2rem;
            ">
            🎉🎉🎉
          </div>
          <div class="h hh">
            {{ $t('add.text51') }}
          </div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.init()
              this.popupVisible = false
            }
          "
          >{{ $t('add.text50') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'fail'">
        <div class="pop-title">
          <span v-if="currentWithdraw === 'web5'">{{ $t('add.text46') }}</span>
          <span v-else>{{ $t('add.text49') }}</span>
        </div>
        <div class="result-box">
          <div class="h icons warning" v-if="currentWithdraw === 'web5'">
            {{ $t('add.text98') }}
          </div>
          <div class="h icons warning" v-else>{{ $t('add.text99') }}</div>
          <div class="des">{{ $t('add.text43') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.popupVisible = false
            }
          "
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.resetFrom()
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>

<script>
import {
  postActivityMine,
  postKrazetokenWithdraw,
  postLogout,
  postNftMyNfts,
  postUserIncome,
  postUserInfo,
  postUserReferral,
  postWeb5tokenWithdraw
} from '@/api/user'
import CopyBox from '@/components/CopyBox.vue'
import EmptyBox from '@/components/EmptyBox.vue'
import SharePop from '@/components/SharePop.vue'

export default {
  name: 'UserAccount',
  components: {
    SharePop,
    EmptyBox,
    CopyBox
  },
  data() {
    return {
      referralList: [],
      selected: '1',
      nftList: null,
      activities: null,
      incomeList: null,
      popupVisible: false,
      popType: null,
      modelForm: {
        token: 10000
      },
      modelForm1: {
        token: 10000
      },
      usdtValue: 10,
      usdtValue1: 10,
      referralParams: {
        page: 1,
        size: 10,
        more: true,
        fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
      },
      nftParams: {
        fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
      },
      fixScroll: 0,
      des: null,
      usdt: false,
      lang: null,
      topStatus: '',
      allLoaded: false,
      loading: false,
      fixwrapper: false,
      callbackUrl: window.location.href,
      sharePath: '',
      showTipss: false,
      currentWithdraw: '',
      nftCategories: [
        {
          label: this.$t('new.text55'),
          data: []
        },
        {
          label: this.$t('new.text56'),
          data: []
        },
        {
          label: this.$t('new.text57'),
          data: []
        }
      ],
      currentNft: 0
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.nftCategories = this.nftCategories.map((item, index) => {
        if (index === 0) {
          item.label = this.$t('new.text55')
        } else if (index === 1) {
          item.label = this.$t('new.text56')
        } else if (index === 2) {
          item.label = this.$t('new.text57')
        }
        return item
      })
      this.init()
    }
    // selected: {
    //   handler(n) {
    //     this.$nextTick(() => {
    //       let scroll
    //       if (this.fixwrapper) {
    //         if (n === '1') {
    //           scroll =
    //             this.nftParams.fixScroll &&
    //             this.nftParams.fixScroll > this.fixScroll
    //               ? this.nftParams.fixScroll
    //               : this.fixScroll
    //         } else if (n === '2') {
    //           scroll =
    //             this.activityParams.fixScroll &&
    //             this.activityParams.fixScroll > this.fixScroll
    //               ? this.activityParams.fixScroll
    //               : this.fixScroll
    //         } else if (n === '3') {
    //           scroll =
    //             this.referralParams.fixScroll &&
    //             this.referralParams.fixScroll > this.fixScroll
    //               ? this.referralParams.fixScroll
    //               : this.fixScroll
    //         }
    //         console.log(n)
    //         console.log(scroll)
    //         let dom = this.$refs.scrollwrapper
    //         dom.scrollTop = scroll
    //       }
    //     })
    //   }
    // }
  },
  created() {
    console.log(8)
    this.init()
  },
  mounted() {
    // let that = this
    // /**
    //  * 监听滚动条 逻辑根据自己需求来哦
    //  */
    // that.$nextTick(() => {
    //   let dom = this.$refs.scrollwrapper
    //   dom.onscroll = function () {
    //     that.fixScroll = that.$refs.fixwrapper.offsetTop // 模块距离顶部距离
    //     console.log(that.fixScroll)
    //     let scroll = dom.scrollTop || dom.pageYOffset // 滚动距离
    //     if (that.selected === '1') {
    //       that.nftParams.fixScroll = scroll
    //     } else if (that.selected === '2') {
    //       that.activityParams.fixScroll = scroll
    //     } else if (that.selected === '3') {
    //       that.referralParams.fixScroll = scroll
    //     }
    //     if (scroll >= that.fixScroll) {
    //       that.fixwrapper = true
    //     } else {
    //       that.fixwrapper = false
    //     }
    //     console.log(scroll)
    //   }
    // })
    if (localStorage.web5_score) {
      this.modelForm.web5_score = localStorage.web5_score
    }
  },

  activated() {
    console.log(9)
    if (this.$store.state.refresh.hasOwnProperty('UserAccount')) {
      this.init()
      this.$store.dispatch('setRefresh', { name: 'UserAccount', type: false })
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.meta.scroll) {
        let dom = vm.$refs.scrollwrapper
        vm.$nextTick(() => {
          dom.scrollTo(0, to.meta.scroll)
        })
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== 'UserNftDetail' &&
      to.name !== 'UserActivity' &&
      to.name !== 'UserAddress'
    ) {
      this.$store.commit('SET_KEEP_ALIVE', [])
    } else {
      let scroll = this.$refs.scrollwrapper.scrollTop
      from.meta.scroll = scroll
    }
    next()
  },
  methods: {
    init() {
      this.lang = localStorage.getItem('lang')
        ? localStorage.getItem('lang')
        : 'en'

      this.getActivityList()
      this.getReferralList()

      let sharePath = this.$store.state.userPath
      if (this.$store.state.user_info && this.$store.state.user_info.rec_code) {
        sharePath += '?inviteCode=' + this.$store.state.user_info.rec_code
      }
      this.sharePath = sharePath

      postNftMyNfts().then((res) => {
        this.nftCategories[0].data = res.data.filter((item) => {
          return item.category_id === 0 || item.category_id === 1
        })
        this.nftCategories[1].data = res.data.filter((item) => {
          return item.category_id === 2
        })
        this.nftCategories[2].data = res.data.filter((item) => {
          return item.category_id === 3
        })
      })
      postUserInfo().then((res) => {
        this.$store.dispatch('UserInfo', res.data)
      })
      postUserIncome().then((res) => {
        this.incomeList = res.data.map((item) => {
          if (item.status === 1) {
            item.statusName = this.$t('inprogress')
          } else if (item.status === 2) {
            item.statusName = this.$t('tobedrawn')
          } else if (item.status === 3) {
            item.statusName = this.$t('finished')
          }
          return item
        })
      })
    },
    getReferralList() {
      this.loading = true
      let params = {
        page: this.referralParams.page,
        size: this.referralParams.size
      }
      postUserReferral(params).then((res) => {
        if (!this.referralList) {
          this.referralList = []
        }
        this.referralList = this.referralList.concat(res.data.lists)
        if (res.data.lists.length < this.referralParams.size) {
          this.referralParams.more = false
        }
        this.loading = false
      })
    },
    getActivityList() {
      this.loading = true
      postActivityMine().then((res) => {
        this.activities = res.data.map((item) => {
          if (item.status === 1) {
            item.statusName = this.$t('inprogress')
          } else if (item.status === 2) {
            item.statusName = this.$t('tobedrawn')
          } else if (item.status === 3) {
            item.statusName = this.$t('finished')
          }
          return item
        })
        this.loading = false
      })
    },
    handleActivity(item) {
      this.handleRoute('/user/activity', item)
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleChange(value) {
      if (value && value < 10000) {
        this.showTipss = true
      } else {
        this.showTipss = false
      }
      let rate = 1 / 1000
      this.usdtValue = (rate * value).toFixed(3)
    },
    handleChange1(value) {
      if (value && value < 10000) {
        this.showTipss = true
      } else {
        this.showTipss = false
      }
      let rate = 1 / 1000
      this.usdtValue1 = (rate * value).toFixed(3)
    },
    handleWithdraw(type) {
      this.currentWithdraw = type
      if (type === 'web5') {
        this.popType = 'withdrawWeb5'
      } else {
        this.popType = 'withdrawKraze'
      }
      this.popupVisible = true
    },
    handleDeposit(type) {
      this.popType = 'type'
      if (type === 'web5') {
        this.popupVisible = true
      } else {
        this.$toast({ message: this.$t('accountpage.text20') })
      }
    },
    handleYes() {
      this.handleRoute('/user/usdtyes')
    },
    handleNo() {
      this.handleRoute('/user/usdtno')
    },
    handleLogout() {
      let that = this
      postLogout().then((res) => {
        that.$toast({
          message: this.$t('accountpage.text19')
        })
        that.$store.dispatch('LogOut')
        that.$router.push('/')
      })
    },
    submitForm(form) {
      if (form === 'modelForm') {
        if (
          this.$store.state.user_info &&
          parseInt(this.$store.state.user_info.web5_score) <
            parseInt(this[form].token)
        ) {
          this.popType = 'fail'
          this.popupVisible = true
        } else {
          this.$refs[form].validate((valid) => {
            if (valid) {
              postWeb5tokenWithdraw(this[form]).then((res) => {
                this.popType = 'success2'
                this.$refs[form].resetFields()
              })
            }
          })
        }
      } else if (form === 'modelForm1') {
        if (
          this.$store.state.user_info &&
          parseInt(this.$store.state.user_info.kraze_token) <
            parseInt(this[form].token)
        ) {
          this.popType = 'fail'
          this.popupVisible = true
        } else {
          this.$refs[form].validate((valid) => {
            if (valid) {
              postKrazetokenWithdraw(this[form]).then((res) => {
                this.popType = 'success3'
                this.$refs[form].resetFields()
              })
            }
          })
        }
      }
    },
    handleShare() {
      if (!this.$store.state.token) {
        this.$bus.emit('handleLogin')
      } else {
        this.popType = 'share'
        this.popupVisible = true
      }
    },
    loadMore() {
      console.log('load')
      if (this.selected === '3') {
        if (this.referralParams.more) {
          this.referralParams.page += 1
          this.getReferralList()
        }
      }
    },
    handleTransfer() {
      this.handleRoute('/user/transferlist')
    },
    handleQa(type) {
      this.$router.push({ path: '/user/qa', query: { type: type } })
    },
    handleSwitdh(index) {
      this.currentNft = index
    },
    resetFrom() {
      this.modelForm = {
        token: 10000
      }
      this.modelForm1 = {
        token: 10000
      }
    }
  }
}
</script>
<style lang="scss">
.deposit {
  .qr-code {
    width: 1.3rem;
    height: 1.3rem;
    background-color: #ffffff;
    margin: 0.25rem auto;
  }
  .link_btn {
    display: block;
    width: 100%;
    font-size: 0.16rem;
    font-weight: 500;
    text-transform: uppercase;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.16rem;
    font-family: 'Roboto Condensed';
    text-align: center;
    text-decoration: none;
    border-radius: 4px;
  }
  .iconprice {
    input {
      background-image: url(~@/assets/images/icon2.svg);
      background-repeat: no-repeat;
      background-position: 98% center;
      background-size: auto 0.18rem;
      padding-right: 0.4rem;
    }
    &.type2 {
      input {
        background-image: url(~@/assets/images/icon1.svg);
      }
    }
  }
  .about {
    margin-top: -0.1rem;
    margin-bottom: 0.2rem;
    text-align: right;
  }
  .tip-box {
    font-weight: 200;
    line-height: 0.22rem;
    margin-top: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/account.vue